import { SCREEN_CLASSES, SCREEN_CLASS_MAX_WIDTHS, SCREEN_CLASS_MIN_WIDTHS } from '../../core/constants/tokens-screen.js';

/**
 * Below are Legacy names and should be avoided in use,
 * as they don't follow any particular naming or casing convention
 */ /**
 * @deprecated Use SCREEN_CLASSES in its place
 */ const screenClasses = SCREEN_CLASSES;
/**
 * @deprecated Use SCREEN_CLASS_MAX_WIDTHS in its place
 */ const screenClassMaxWidths = SCREEN_CLASS_MAX_WIDTHS;
/**
 * @deprecated Use SCREEN_CLASS_MIN_WIDTHS in its place
 */ const screenClassMinWidths = SCREEN_CLASS_MIN_WIDTHS;

export { screenClassMaxWidths, screenClassMinWidths, screenClasses };
